module.exports = __webpack_public_path__ + "img/RGallicHorseman64_ua.604010f8.webp";